<template>
  <AppHeader :action="{text: 'Add', route: 'CreateLead'}">Sample Requests</AppHeader>

  <Loading v-if="state == 'loading'"></Loading>

  <div v-if="state == 'idle'" class="p-4">
    <SearchSort
      ref="search"
      :defaults="{q: '', search: '-', sort: 'id', order: 'asc', group: '-'}"
      :sorts="{id: 'Sample ID', created_at: 'Created At', name: 'Name', area_id: 'Area ID', delivery_person_id: 'Delivery Person ID', assigned_at: 'Assigned At', status: 'Status', sample_quantity: 'Sample Quantity', delivery_date: 'Delivery Date', payment_date: 'Payment Date', payment_status: 'Payment Status'}"
      :columns="{id: 'ID', status: 'Status', name: 'Name', area: 'Area', status: 'Status'}"
      :groups="[]"
      @update="searchUpdated">
    </SearchSort>

    <div class="mt-4 responsive-table">
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Area</th>
            <th>Address</th>
            <th>Quantity</th>
            <th>Groups</th>
            <th>Created</th>
            <th>Assinged</th>
            <th>Paid</th>
            <th>Payment Status</th>
            <th>Status</th>
            <th>Map</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>

          <tr v-for="lead in filtered" :class="{'bg-green-300': lead.status == 'delivered', 'bg-yellow-300': lead.status == 'not-reachable'}" :key="lead.id">
            <td><small>#{{ lead.id }}</small></td>
            <td class="flex items-center gap-x-2">
              <a @click="initiateCall(lead.phone)"><b>{{ lead.name }} </b></a>
              <p class="p-0 text-xl text-green-600" v-if="lead.payment_status == 'paid'"> <i class="icon ion-md-cash"></i></p>
              <p class="p-0 text-lg text-gray-500" v-if="lead.is_auto_assigned && lead.status == 'assigned'"> <i class="icon ion-md-locate"></i></p>
            </td>
            <td>{{ lead.area.name }}</td>
            <td>{{ lead.address }}</td>
            <td>{{ lead.sample_quantity }} ({{ toDate(lead.delivery_date) }})</td>
            <td>
              <select @change="updateCustomerGroup($event.target.value, lead)" class="px-2 text-sm text-gray rounded-md">
                <option value="">-- SET GROUP --</option>
                <option v-for="grp in data.customer_groups" :value="grp.id" :selected="grp.id == lead.group_id" :key="grp.id">{{ grp.name }}</option>
              </select>
            </td>
            <td>{{ toDate(lead.created_at, true) }}</td>
            <td>{{ toDate(lead.assigned_at, true) }}</td>
            <td>{{ toDate(lead.payment_date, false, '') }}</td>
            <td>{{ lead.payment_status }}</td>
            <td>{{ lead.status }}</td>
            <td>
              <a v-if="lead.map_location" :href="lead.map_location" target="_system" class="px-3 py-1 mr-1 text-sm text-white bg-green-600 rounded-full" title="View Customer Location"><i class="ion-md-pin"></i></a>
              <router-link :to="{name: 'ViewLead', params: {id: lead.id}}" class="px-3 py-1 text-xs text-white rounded-full bg-slate-500" title="Set Customer Location on Map">Set on Map</router-link>
            </td>
            <td>
              <span v-if="lead && lead.sample_image" class="px-3 py-1 mr-1 text-sm text-white bg-zinc-500 rounded-full">
                <a :href="lead.sample_image.src" target="_system" title="View Sample"><i class="ion-md-image"></i></a>
              </span>

              <span v-if="lead.status == 'assigned'">
                <button v-if="(lead.sample_image || lead.delivery_updated_at) && data.dealer_type == 'Company Dealership'" @click="updateLead(lead.id, 'delivered')" class="px-2 py-1 mr-1 text-sm text-white bg-blue-500 rounded-full">Delivered</button>
                <button v-if="data.dealer_type == 'Dealer'" @click="updateLead(lead.id, 'delivered')" class="px-2 py-1 mr-1 text-sm text-white bg-blue-500 rounded-full">Delivered</button>
                <button @click="updateLead(lead.id, 'onhold')" class="px-2 py-1 mr-1 text-sm text-white bg-yellow-500 rounded-full">Hold</button>
                <button @click="updateLead(lead.id, 'not-reachable')" class="px-2 py-1 mr-1 text-sm text-white rounded-full bg-slate-500">Not Reachable</button>
                <button @click="updateLead(lead.id, 'rejected')" class="px-2 py-1 mr-1 text-sm text-white bg-red-600 rounded-full">Customer Rejected</button>
                <button @click="updateLead(lead.id, 'no-service')" class="px-2 py-1 mr-1 text-sm text-white rounded-full bg-amber-600">Not Serviceable</button>
              </span>

              <span v-if="lead.status == 'onhold'">
                <button v-if="(lead.sample_image || lead.delivery_updated_at) && data.dealer_type == 'Company Dealership'" @click="updateLead(lead.id, 'delivered')" class="px-2 py-1 mr-1 text-sm text-white bg-blue-500 rounded-full">Delivered</button>
                <button v-if="data.dealer_type == 'Dealer'" @click="updateLead(lead.id, 'delivered')" class="px-2 py-1 mr-1 text-sm text-white bg-blue-500 rounded-full">Delivered</button>
                <button @click="updateLead(lead.id, 'not-reachable')" class="px-2 py-1 mr-1 text-sm text-white rounded-full bg-slate-500">Not Reachable</button>
                <button @click="updateLead(lead.id, 'no-service')" class="px-2 py-1 mr-1 text-sm text-white rounded-full bg-amber-600">Not Serviceable</button>
              </span>

              <span v-if="lead.status == 'not-reachable'">
                <button v-if="(lead.sample_image || lead.delivery_updated_at) && data.dealer_type == 'Company Dealership'" @click="updateLead(lead.id, 'delivered')" class="px-2 py-1 mr-1 text-sm text-white bg-blue-500 rounded-full">Delivered</button>
                <button v-if="data.dealer_type == 'Dealer'" @click="updateLead(lead.id, 'delivered')" class="px-2 py-1 mr-1 text-sm text-white bg-blue-500 rounded-full">Delivered</button>
                <button @click="updateLead(lead.id, 'no-service')" class="px-2 py-1 mr-1 text-sm text-white rounded-full bg-amber-600">Not Serviceable</button>
              </span>

              <span v-if="lead.status == 'delivered'">
                <button @click="updateLead(lead.id, 'converted')" class="px-2 py-1 mr-1 text-sm text-white bg-green-600 rounded-full">Converted</button>
                <button @click="updateLead(lead.id, 'not-converted')" class="px-2 py-1 mr-1 text-sm text-white rounded-full bg-red-600">Not Converted</button>
                <button @click="updateLead(lead.id, 'no-service')" class="px-2 py-1 mr-1 text-sm text-white rounded-full bg-amber-600">Not Serviceable</button>
                <button @click="goToBottleExchange(lead.id, lead.name)" class="px-2 py-1 mr-1 text-sm text-white rounded-full bg-blue-600">Bottle</button>
              </span>

              <span v-if="lead.payment_status == 'paid' && lead.status != 'delivered'">
                <button @click="initiateMessage('lead', lead.id, 'sms', 'sample_delivery_update')" class="px-2 py-1 mr-1 text-sm text-white rounded-full bg-green-600">Send SMS</button>
              </span>
            </td>
          </tr>

          <tr v-if="data.leads.length == 0">
            <td class="text-xl text-center text-gray-500" colspan="100%">No Samples</td>
          </tr>

        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import mixin from '@/utils/mixin.js';
import AppHeader from '@/components/common/Header.vue';
import Loading from '@/components/common/Loading.vue';
import SearchSort from '@/components/common/SearchSort.vue';

export default {
  name: 'Leads',
  mixins: [ mixin ],
  components: { AppHeader, Loading, SearchSort },
  data() {
    return {
      state: 'loading',
      filtered: [],
      data: { leads: [], delivery_persons: [] },
    }
  },

  methods: {
    getData() {
      this.state = 'loading';

      this.request('GET', 'leads', {}, (resp) => {
        this.state = 'idle';
        if (resp.success) {
          this.data = resp.data;
          this.filtered = resp.data.leads;
        }
      });
    },

    updateLead(id, status) {
      this.state = 'loading';

      this.request('POST', 'leads/' + id + '/' + status, {}, (resp) => {
        this.state = 'idle';
        if (resp.success) {
          this.data = resp.data;
          this.filtered = resp.data.leads;
        } else alert(resp.message);
      });
    },

    goToBottleExchange(leadId, leadName) {
      this.$router.push({ name: 'BottleExchangeCreate', params: {id: leadId}, query: {type: 'lead', name: leadName} });
    },

    updateCustomerGroup(groupId, lead) {
      let selectedGroup = this.data.customer_groups.find(grp => grp.id == groupId) || {id: null, delivery_person_id: null};
      if (selectedGroup.id == lead.group_id && selectedGroup.delivery_person_id == lead.delivery_person_id) return;
      
      this.state = 'loading';

      this.request('POST','leads/' + lead.id + '/set-customer-groups',{group_id: selectedGroup.id,delivery_person_id: selectedGroup.delivery_person_id},
        (resp) => {
          this.state = 'idle';

          if (resp.success) {
            this.getData();
          } else {
            alert(resp.message);
          }
        }
      );
    },

    searchUpdated(q, search, sort, order) {
      if (!q ||q == null || q.length == 0) this.filtered = this.data.leads;

      if (search == '-') this.filtered = this.data.leads.filter((item) => JSON.stringify(item).toLowerCase().includes(q.toLowerCase()));
      else this.filtered = this.data.leads.filter((item) => JSON.stringify(this.getDeepValue(item, search)).toLowerCase().includes(q.toLowerCase()));

      this.filtered.sort((a, b) => {
        let aData = this.getDeepValue(a, sort), bData = this.getDeepValue(b, sort);
        return (aData == bData ? 0 : aData < bData ? -1 : 1) * (order == 'desc' ? -1 : 1);
      });
    },
  },

  created() {
    if (!this.$store.state.api_token) this.$router.push('/');
    else this.getData();
  }
}
</script>
